import { QueryClient } from "@tanstack/react-query";

import { STALE_TIME } from "#app/http/ReactQueryProvider";
import {
  CustomSurfaceTreatmentsDto,
  fetchCustomSurfaceTreatments,
} from "#modules/companySettings/infra/fetchCustomSurfaceTreatments.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const customSurfaceTreatmentsQuery = (companyId: string | undefined) => ({
  queryKey: queryKeys.customSurfaceTreatments.detail(companyId),
  queryFn: () => fetchCustomSurfaceTreatments(companyId || ""),
  staleTime: STALE_TIME,
  enabled: !!companyId,
});

export const getCustomSurfaceTreatmentsQueryData = (
  queryClient: QueryClient,
  companyId: string,
): CustomSurfaceTreatmentsDto | null | undefined => {
  return queryClient.getQueryData<CustomSurfaceTreatmentsDto | null>(
    queryKeys.customSurfaceTreatments.detail(companyId),
  );
};

type CustomSurfaceTreatmentsQueryDataUpdater =
  | CustomSurfaceTreatmentsDto
  | null
  | undefined
  | ((
      old: CustomSurfaceTreatmentsDto | null | undefined,
    ) => CustomSurfaceTreatmentsDto | null | undefined);

export const setCustomSurfaceTreatmentsQueryData = (
  queryClient: QueryClient,
  companyId: string,
  updater: CustomSurfaceTreatmentsQueryDataUpdater,
): CustomSurfaceTreatmentsDto | null | undefined => {
  return queryClient.setQueryData<CustomSurfaceTreatmentsDto | null>(
    queryKeys.customSurfaceTreatments.detail(companyId),
    updater,
  );
};
